import { Box } from '@breathelife/mui';
import { ReactElement, Fragment } from 'react';

import { DynamicPdfComponentSpecification, PdfVariant } from '@breathelife/types';

import { ComponentFactory } from '../../Components/PdfComponents/ComponentVariants/ComponentFactory';
import usePdfContext from '../../Context/usePdfContext';

export function PadPdf(): ReactElement | null {
  const { componentSelection, variant } = usePdfContext();

  if (typeof variant === 'undefined' || variant in PdfVariant === false) {
    throw new Error(`Pdf variant undefined or not valid.`);
  }
  if (typeof componentSelection === 'undefined' || componentSelection?.length === 0) {
    throw new Error(`No components selected.`);
  }

  const renderedComponents = componentSelection.map((component: DynamicPdfComponentSpecification, index: number) => {
    return <Fragment key={index}>{ComponentFactory(component, variant)}</Fragment>;
  });

  return <Box p={2}>{renderedComponents}</Box>;
}
